webpackJsonp([186873666987998],{

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/shyamala-big.33315903.jpg";

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Shyamala = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(585);
	
	var _shyamalaBig = __webpack_require__(933);
	
	var _shyamalaBig2 = _interopRequireDefault(_shyamalaBig);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contentPage = __webpack_require__(16);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(17);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://www.winpeforum.com/assets/elements/shanti.jpg";
	
	var Shyamala = exports.Shyamala = function (_React$Component) {
	  _inherits(Shyamala, _React$Component);
	
	  function Shyamala(args) {
	    _classCallCheck(this, Shyamala);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.state;
	    return _this;
	  }
	
	  Shyamala.prototype.render = function render() {
	    var location = this.props.location;
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Winpe ProClub Advisory Board | Shanti Ekambaram",
	        description: "Shanti Ekambaram is a distinguished banking business and governance leader with 39 years\r\nof financial services experience, including an exceptional 35-year tenure at Kotak Mahindra\r Bank where she was a part of the team that shaped the institution's transformation from a pre-\r\nIPO non-banking financial company to one of India's most respected universal banks.",
	        image: "https://winpeforum.com/assets/elements/shanti.jpg",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "advisor-section" },
	        _react2.default.createElement(
	          "div",
	          { className: "back_event" },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/home/" },
	            _react2.default.createElement(
	              "i",
	              { className: "fa fa-arrow-left" },
	              " Back"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "h1",
	            { className: "heading text-center" },
	            "Advisory Board"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "advisor-section" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 content-section" },
	                _react2.default.createElement("img", { className: "wrapper-image", src: icon1, alt: "" }),
	                _react2.default.createElement(
	                  "h1",
	                  null,
	                  "Shanti Ekambaram"
	                ),
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  "Former Deputy Managing Director & Whole-time Director"
	                ),
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  "Strategic Transformation & Governance"
	                ),
	                _react2.default.createElement("h3", null),
	                _react2.default.createElement(
	                  "div",
	                  { className: "para" },
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Shanti Ekambaram is a distinguished banking business and governance leader with 39 years of financial services experience, including an exceptional 35-year tenure at Kotak Mahindra Bank where she was a part of the team that shaped the institution's transformation from a pre- IPO non-banking financial company to one of India's most respected universal banks. Her career exemplifies the rare combination of, strategic vision, deep business orientation, operational expertise and governance acumen that modern boards seek in their directors. ",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "Most recently serving as Deputy Managing Director and Whole-time Director (2022-2025), Shanti provided strategic oversight across Treasury, Balance Sheet Management, Digital Banking (811), Human Resources, Internal Audit, Vigilance, CSR/ESG, and Kotak's capital market subsidiaries. In this role, she chaired the First Tier Audit Committee and POSH Committee, demonstrating her commitment to financial integrity, regulatory compliance, and organizational culture. Her stewardship during this period guided the Bank through external markets volatility and regulatory transitions while delivering stakeholder value.",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "Shanti's career is distinguished by her institution-building capabilities across multiple business verticals and she has a unique blend of Corporate, Retail and Digital business experience.. As President of Consumer Banking (2014-2022), she led the strategic transformation of the division through India's largest same-size bank merger\u2014the integration of ING Vysya Bank\u2014 while simultaneously pioneering digital banking innovation. The launch of 811 in March 2017, India's first Aadhaar-enabled, zero-balance digital banking platform, required unprecedented collaboration with regulators including RBI and UIDAI, establishing new paradigms for digital onboarding that have since become industry standard. Her ability to navigate the regulatory disruption of demonetization (November 2016) and position the Bank for accelerated digital adoption demonstrated strategic agility and crisis leadership.",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "Earlier, as President of Wholesale Banking (2003-2014), Shanti architected the business from inception following Kotak's banking license acquisition. She established comprehensive governance frameworks, risk policies, and compliance infrastructure across corporate banking, SME, financial institutions, debt capital markets, custody, and transaction banking. Her leadership during the 2008 global financial crisis\u2014navigating through the Lehman Brothers collapse with zero credit stress\u2014validated her conservative risk philosophy and , protecting shareholder value during one of history's most turbulent financial periods.",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "Perhaps most significantly for India's capital markets, Shanti served as CEO of Kotak Mahindra Capital Company (1997-2003), the investment banking joint venture with Goldman Sachs. She led a team that pioneered the transformation of India's equity capital markets by leading the Hughes Software IPO in 1999\u2014the country's first book-building transaction. This landmark achievement required intensive collaboration with SEBI, investors, and market participants to fundamentally reform IPO mechanisms, replacing archaic systems with global standards. The governance frameworks and market practices that were established persist today, demonstrating her capacity to drive systemic change through regulatory partnership and industry leadership.",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "Her leadership of Kotak's CSR and ESG strategy reflects values-driven decision-making that extends beyond compliance to genuine stakeholder impact.",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "A Chartered Accountant and Cost and Management Accountant, Shanti brings the business expertise and technical financial expertise and audit committee qualifications that boards require for oversight of complex financial institutions.",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "She currently serves on the boards of Kotak Mahindra Capital Company, Kotak Securities, and the Indian Institute of Management, Bangalore, where she contributes strategic direction to India's premier business education institution.",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "Beyond her professional achievements, Shanti's commitment to ESG and social impact is deeply rooted and authentic. She has been involved at the founder level with SOPAN (Society of Parents of Children with Autistic Disorders), an autism advocacy organization, and consistently fundraises for social causes through her participation in the Mumbai Marathon. Shanti's industry recognition underscores her standing as a preeminent business leader. She was ranked No. 1 on the Candere Hurun India Women Leaders List 2025 and named Businesswoman of the Year 2025 by The CEO Magazine. She has been consistently recognized by Fortune India's '50 Most Powerful Women in Business' and Business Today's 'Most Powerful Women in Indian Business' throughout her career, reflecting sustained excellence and impact.",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "As she transitions to board director and strategic advisory roles post-retirement from Kotak Mahindra Bank in October 2025, Shanti seeks opportunities where her extensive governance expertise, financial acumen, regulatory navigation capabilities, and transformational leadership can guide organizations through strategic inflection points.",
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null),
	                    "Shanti\u2019s proven ability to build institutions, drive market innovation, navigate crises, and maintain unwavering commitment to governance standards positions her as an exceptional addition to boards seeking directors who combine strategic vision with fiduciary discipline and genuine stakeholder orientation."
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Shyamala;
	}(_react2.default.Component);
	
	Shyamala.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = Shyamala;

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-shanti-ekambaram-index-jsx-e7b5ec1cb067067a3597.js